import { CheckCheck, Eye } from "lucide-react";
import { InlineActionButton } from "@/components/ui/InlineActionButton";

type ProductRequestAlertActionsProps = {
  canMarkSeen: boolean;
  isBusy: boolean;
  canResolve: boolean;
  onMarkSeen: () => void;
  onOpenProductReview: () => void;
};

export function ProductRequestAlertActions({
  canMarkSeen,
  isBusy,
  canResolve,
  onMarkSeen,
  onOpenProductReview,
}: ProductRequestAlertActionsProps) {
  return (
    <>
      {canMarkSeen && (
        <InlineActionButton
          onClick={onMarkSeen}
          disabled={isBusy}
          icon={<Eye size={12} />}
        >
          Marcar visto
        </InlineActionButton>
      )}
      {canResolve ? (
        <InlineActionButton
          tone="success"
          onClick={onOpenProductReview}
          icon={<CheckCheck size={12} />}
        >
          Resolver
        </InlineActionButton>
      ) : null}
    </>
  );
}
